<template>
  <div>
    <header class="header header-contact">
      <div class="header-content">
        <h1>Vous souhaitez réserver une table ou commander à emporter ?</h1>
      </div>
    </header>

    <div class="container">
      <div class="contact-section">
        <div class="contact-info">
          <div class="info-card">
            <h2>
              Contacter nous pour réserver une table ou commander à emporter
            </h2>

            <div class="divider"></div>

            <div class="contact-details">
              <div class="contact-item">
                <h3>Notre adresse</h3>
                <p>48 rue du Fort Saint-Georges | 10220 Géraudot</p>
              </div>

              <div class="contact-item">
                <h3>Numéro de téléphone</h3>
                <p>03 25 80 37 31</p>
              </div>

              <div class="social-links">
                <a
                  href="https://www.facebook.com/profile.php?id=100063190451556"
                  class="social-icon"
                  ><i class="fa-brands fa-facebook"></i
                ></a>
                <a
                  href="https://www.instagram.com/la_pizza_du_lac/"
                  class="social-icon"
                  ><i class="fa-brands fa-instagram"></i
                ></a>
              </div>
            </div>
          </div>
        </div>

        <div class="map-container">
          <Googlemap />
        </div>
      </div>

      <div class="cta-section">
        <h2>Restez connecté avec nous</h2>
        <p>
          Appelez le restaurant pour passer votre commande à emporter ou pour
          réserver une table dans notre restaurant.
        </p>
        <router-link class="btn btn-primary" :to="{ name: 'menu' }"
          >Commander ou Réserver</router-link
        >
      </div>
    </div>

    <footer>
      <div class="footer-content">
        <p>
          &copy; {{ new Date().getFullYear() }} La Pizza du Lac. Tous droits
          réservés.
        </p>
      </div>
    </footer>
  </div>
</template>

<script >
import { useHead } from '@vueuse/head'
import { organizationSchema, injectSchema, breadcrumbSchema } from '@/utils/seoConfig'
import Googlemap from "@/components/Googlemap.vue";

export default {
  name: "ContactPage",
  components: {
    Googlemap,
  },
  setup() {
    useHead({
      title: 'Nous Contacter - La Pizza du Lac',
      meta: [
        {
          name: 'description',
          content: 'Contactez La Pizza du Lac pour réserver une table ou commander à emporter. Adresse: 48 rue du Fort Saint-Georges, 10220 Géraudot. Téléphone: 03 25 80 37 31'
        },
        {
          property: 'og:title',
          content: 'Nous Contacter - La Pizza du Lac'
        },
        {
          property: 'og:description',
          content: 'Réservez une table ou commandez à emporter. Retrouvez nos coordonnées et localisation.'
        },
        {
          property: 'og:type',
          content: 'website'
        }
      ]
    })
  },
  mounted() {
    // Injecter les schemas JSON-LD
    injectSchema(organizationSchema)
    injectSchema(breadcrumbSchema([
      { name: 'Accueil', url: 'https://lapizzadulac.com/' },
      { name: 'Contact', url: 'https://lapizzadulac.com/contact' }
    ]))
  },

};
</script>

<style lang="scss" scoped>
// Variables
$primary-color: #fdcb41;
$dark-bg: #ffcc85;
$light-bg: #fffbf3;
$text-dark: #333;
$text-light: #666;
$white: #fff;
$transition-default: all 0.3s ease;
$box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
$box-shadow-hover: 0 15px 30px rgba(0, 0, 0, 0.15);
$border-radius: 10px;

// Réinitialisation et styles de base
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Poppins", sans-serif;
}

body {
  background-color: $light-bg;
  color: $text-dark;
  line-height: 1.6;
}

// En-tête
.header {
  background: linear-gradient(135deg, 0%, $dark-bg 100%);
  color: $white;
  padding: 60px 20px;
  text-align: center;
  position: relative;

  &-contact {
    background-image: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)),
      url("https://images.unsplash.com/photo-1513104890138-7c749659a591");
    background-size: cover;
    background-position: center;
    padding: 80px 20px;
  }

  &-content {
    padding: 100px 0 0 0;
    max-width: 800px;
    margin: 0 auto;
  }

  h1 {
    font-size: 42px;
    margin-bottom: 10px;
    font-weight: 700;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    line-height: 1.3;
  }
}

// Section principale
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}

// Contact Section
.contact-section {
  display: flex;
  flex-wrap: wrap;
  gap: 40px;
  margin-bottom: 60px;
}

.contact-info {
  flex: 1 1 450px;
}

.info-card {
  background-color: $white;
  border-radius: $border-radius;
  padding: 40px;
  box-shadow: $box-shadow;
  height: 100%;

  h2 {
    font-size: 26px;
    margin-bottom: 25px;
    color: $text-dark;
    text-align: center;
    line-height: 1.4;
  }
}

.divider {
  height: 3px;
  width: 60px;
  background-color: $primary-color;
  margin: 0 auto 30px;
  border-radius: 3px;
}

.contact-details {
  margin-top: 30px;
}

.contact-item {
  margin-bottom: 25px;

  h3 {
    font-size: 18px;
    color: $primary-color;
    margin-bottom: 8px;
  }

  p {
    font-size: 16px;
    color: $text-light;
  }
}

.social-links {
  display: flex;
  gap: 15px;
  margin-top: 30px;
  justify-content: center;
}

.social-icon {
  font-size: 30px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: $dark-bg;
  color: $white;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transition: $transition-default;

  &:hover {
    background-color: $primary-color;
    transform: translateY(-3px);
  }
}

.map-container {
  flex: 1 1 500px;
  border-radius: $border-radius;
  overflow: hidden;
  box-shadow: $box-shadow;
}

.map-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

// CTA Section
.cta-section {
  background-image: linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)),
    url("https://images.unsplash.com/photo-1544025162-d76694265947");
  background-size: cover;
  background-position: center;
  padding: 80px 40px;
  border-radius: $border-radius;
  text-align: center;
  color: $white;
  margin: 60px 0;

  h2 {
    font-size: 32px;
    margin-bottom: 20px;
  }

  p {
    font-size: 18px;
    max-width: 700px;
    margin: 0 auto 30px;
    opacity: 0.9;
  }
}

// Button
.btn {
  color: black;
  text-decoration: none;
  display: inline-block;
  padding: 12px 25px;
  border-radius: 30px;
  text-decoration: none;
  font-weight: 600;
  transition: $transition-default;
  border: 2px solid transparent;
  cursor: pointer;

  &-primary {
    background-color: $primary-color;
    color: $text-dark, 5%;
    border-color: $primary-color;

    &:hover {
      background-color: transparent;
      color: $primary-color;
    }
  }
}

// Pied de page
footer {
  background-color: $dark-bg;
  color: $white;
  text-align: center;
  padding: 30px 20px;

  .footer-content {
    max-width: 800px;
    margin: 0 auto;
  }
}

// Media queries pour la responsivité
@media (max-width: 768px) {
  .header {
    h1 {
      font-size: 32px;
    }
  }

  .contact-section {
    flex-direction: column;
  }

  .info-card h2 {
    font-size: 22px;
  }

  .cta-section {
    padding: 50px 20px;

    h2 {
      font-size: 26px;
    }

    p {
      font-size: 16px;
    }
  }
}
</style>